import _ from "lodash";

export const useFilters = () => ({
  uppercase: function (value) {
    return _.toUpper(value);
  },
  lowercase: function (value) {
    return _.toLower(value);
  },
  capitalize: function (value) {
    return _.capitalize(value);
  },
  currency: function(value) {
    return value.toLocaleString('it-IT', {
      currency: 'EUR',

      style: 'currency'
    });
  },
  localDate: function(value) {
    return `${value.giorno || '??'}/${value.mese || '??'}/${value.anno || '??'}`;
  },
  absolutURL: function(relativePath) {
    return `${window ? window.location.origin : './'}${relativePath}`
  },
  joinUnique: function (arrayValue) {
    return _.uniq(arrayValue).join(', ')
  }
})
